import React from "react";
import "../Styles/Footer.css";
import only_icon from "../Assets/only-icon.png";

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-container">

        {/* Brand Info */}
        <div className="ft-brand-card">

          <div className="ft-brand-header">
            <img
              src={only_icon}
              alt="Workforce Nexus Icon"
              className="ft-brand-icon"
            />
            <p className="ft-title">Workforce Nexus</p>
          </div>

          <p className="ft-description">
            Connect with Workforce Nexus for reliable recruitment support,
            industry-focused hiring solutions, and professional talent sourcing
            designed to help businesses secure the right workforce faster and
            more effectively.
          </p>

          <div className="ft-brand-badge">
            Where Excellence Meets Expectations
          </div>
        </div>

        {/* Services */}
        <div className="ft-list-card">
          <p className="ft-list-title">Services</p>

          <ul className="ft-list-items">
            <li>Recruitment Support</li>
            <li>Talent Sourcing</li>
            <li>Industry-Specific Hiring</li>
            <li>Workforce Consultation</li>
            <li>Global Recruitment Solutions</li>
          </ul>
        </div>

        {/* Contact */}
        <div className="ft-list-card" id="contact">
          <p className="ft-list-title">Connect Us</p>

          <ul className="ft-contact-items">
            <li>
              <a href="mailto:mail.workforcenexus@gmail.com">
                mail.workforcenexus@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+917977602121">
                +91 7977602121
              </a>
            </li>
          </ul>

          <div className="ft-contact-note">
            Professional hiring support tailored for modern businesses.
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="ft-copyright">
        <p>© 2026 Workforce Nexus. All rights reserved.</p>

        {/* <ul className="ft-social-links">
          <li>
            <a
              href="https://www.linkedin.com/company/workforce-nexus/"
              title="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
              </svg>
            </a>
          </li>

          <li>
            <a
              href="https://wa.me/917977602121"
              title="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32 100.3 32 0 132.3 0 255.9c0 39.8 10.4 78.7 30.2 113L0 480l114.7-30c33.5 18.3 71.3 28 109.2 28h.1c123.6 0 223.9-100.3 223.9-223.9 0-59.3-23.1-115.1-67-157zM223.9 438c-33.8 0-66.9-8.8-96.1-25.5l-6.9-4-68.1 17.9 18.2-66.3-4.5-6.8c-18-28.7-27.5-61.9-27.5-96.4 0-101.4 82.5-183.9 183.9-183.9 49.1 0 95.3 19.1 130 53.9 34.7 34.7 53.9 80.9 53.8 130-.1 101.4-82.6 183.8-184 183.8zm101-138.3c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.5-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-53.9-29.1-75.4-65.8-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.5-19.4 19-19.4 46.3 0 27.3 19.9 53.6 22.6 57.3 2.8 3.7 39.1 59.7 94.8 83.7 35.2 15.2 48.9 16.4 66.5 13.8 10.8-1.6 32.8-13.4 37.4-26.3 4.6-12.9 4.6-24 3.2-26.3-1.3-2.3-5-3.7-10.6-6.5z" />
              </svg>
            </a>
          </li>
        </ul> */}
      </div>
    </footer>
  );
}

export default Footer;